var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1781_7871)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(0.999996 0.00264635 0.00198484 0.999998 0 0.433891)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3669 39.3323L24.3616 39.3323C22.2411 39.3316 20.1575 38.7743 18.3069 37.7169L11.5903 39.5625L13.3878 32.6846C12.279 30.6716 11.6956 28.3883 11.6966 26.049C11.6993 18.7308 17.3831 12.7768 24.3667 12.7768C27.7561 12.7783 30.9372 14.1606 33.3295 16.6695C35.7216 19.1782 37.0382 22.513 37.0368 26.0595C37.0341 33.3761 31.3526 39.3293 24.3669 39.3323ZM18.6178 35.314L19.0023 35.5531C20.6192 36.5583 22.4726 37.0901 24.3622 37.0909L24.3665 37.0909C30.1707 37.0909 34.8949 32.1418 34.8974 26.0587C34.8983 23.1109 33.804 20.3393 31.8159 18.2539C29.8274 16.1687 27.1835 15.0197 24.3707 15.0187C18.5619 15.0187 13.8377 19.9673 13.8354 26.0498C13.8346 28.1344 14.3914 30.1644 15.4455 31.9209L15.6959 32.3382L14.6321 36.4093L18.6178 35.314ZM30.3167 28.9172C30.5374 29.0289 30.6865 29.1044 30.7502 29.2158C30.8294 29.3541 30.8294 30.0181 30.5658 30.7929C30.3017 31.5675 29.037 32.2748 28.4288 32.3697C27.8834 32.4552 27.1932 32.4909 26.4348 32.2385C25.975 32.0855 25.3853 31.8814 24.63 31.5398C21.6621 30.1973 19.6564 27.1838 19.2774 26.6143C19.2508 26.5744 19.2322 26.5465 19.2219 26.532L19.2193 26.5284C19.0518 26.2943 17.9292 24.7252 17.9292 23.1012C17.9292 21.5736 18.6455 20.7728 18.9752 20.4043C18.9978 20.379 19.0186 20.3558 19.0372 20.3345C19.3274 20.0025 19.6704 19.9195 19.8814 19.9195C20.0924 19.9195 20.3037 19.9215 20.4882 19.9312C20.5109 19.9324 20.5346 19.9323 20.5591 19.9321C20.7435 19.931 20.9736 19.9295 21.2005 20.5005C21.2877 20.7202 21.4155 21.0459 21.5502 21.3895C21.8226 22.0843 22.1236 22.852 22.1766 22.963C22.2557 23.1291 22.3085 23.3227 22.203 23.5441C22.1871 23.5773 22.1725 23.6086 22.1584 23.6386C22.0792 23.8081 22.0209 23.9328 21.8864 24.0973C21.8335 24.162 21.7788 24.2318 21.7242 24.3015C21.6152 24.4405 21.5063 24.5794 21.4115 24.6784C21.253 24.8438 21.088 25.0232 21.2727 25.3552C21.4574 25.6873 22.0927 26.7733 23.0339 27.6527C24.0455 28.598 24.9248 28.9975 25.3705 29.2001C25.4575 29.2396 25.5281 29.2717 25.5798 29.2988C25.8962 29.4649 26.0809 29.4371 26.2656 29.2158C26.4503 28.9944 27.057 28.2473 27.268 27.9154C27.479 27.5835 27.6902 27.6388 27.9803 27.7494C28.2705 27.8602 29.827 28.6624 30.1435 28.8284C30.2053 28.8608 30.2631 28.89 30.3167 28.9172Z",
    fill: "url(#paint0_linear_1781_7871)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1781_7871",
    x1: 24.3135,
    y1: 12.7768,
    x2: 24.3135,
    y2: 39.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62FD7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26D044"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1781_7871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(0.999996 0.00264635 0.00198484 0.999998 0 0.433891)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.063f41f0b86098c3ba0bf9a5bb1e8f54.svg";
export { ForwardRef as ReactComponent };